import React from 'react';

import Alert from '../icons-af/alert';
import './info-icon.scss';

const InfoIcon = ({text, size}: infoIconProps) => {
  return (
    <span className="info-icon" title={text}>
      <Alert width={size ? size : '100%'} height={size ? size : '100%'} />
    </span>
  );
};

export interface infoIconProps {
  text: string;
  size?: string;
}

export default InfoIcon;
